import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { useQuery, useApolloClient, useMutation } from '@apollo/react-hooks';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Spin from 'components/common/Spin';
import Button from 'components/common/Button';
import { GET_NOTIFICATIONS, MARK_READ } from 'graphql/notification';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { getURL } from 'utils/notifications';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#D2D7E3',
    marginRight: theme.spacing(2),
  },
  paper: {
    transformOrigin: 'top right',
  },
  list: {},
  listItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  footer: {
    textAlign: 'center',
  },
}));

const NotificationPage = ({}) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const [count, setCount] = useState(0);
  const [messages, setMessages] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const client = useApolloClient();
  const [markReadMutation] = useMutation(MARK_READ);
  useEffect(() => {
    fetch();
  }, [offset]);

  const fetch = () => {
    client
      .query({
        query: GET_NOTIFICATIONS,
        variables: {
          userId: user.type === 'admin' ? 0 : user.id,
          limit: 20,
          offset,
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        const count = data ? data.count_aggregate.aggregate.count : 0;
        const messageList = data ? data.notifications : [];
        setCount(count);
        setMessages([...messages, ...messageList]);
        setHasMore(messageList.length === 20);
      });
  };

  const handleRead = (id) => {
    markReadMutation({
      variables: {
        id,
      },
    });
  };

  const onLoadMore = () => {
    setOffset(offset + 20);
  };

  return (
    <div>
      <Typography gutterBottom variant="h5">
        Notifications ({count})
      </Typography>
      <div>
        <List className={classes.list}>
          {messages.map((message, index) => (
            <React.Fragment key={message.id}>
              <ListItem
                disableGutters
                alignItems="flex-start"
                className={classes.listItem}
              >
                <Typography gutterBottom variant="body2">
                  <Link
                    to={getURL(message)}
                    onClick={() => handleRead(message.id)}
                  >
                    {' '}
                    {message.message}{' '}
                  </Link>
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {moment.tz(message.created_at, user.timezone).format('LLL')}
                </Typography>
              </ListItem>
              {index < messages.length - 1 ? (
                <Divider className={classes.divider} />
              ) : null}
            </React.Fragment>
          ))}
        </List>
        <div className={classes.footer}>
          {hasMore ? (
            <Button variant="contained" color="primary" onClick={onLoadMore}>
              Load more
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NotificationPage;
